import React from 'react';

import { DetailText } from '../../Confirm-styled-components';

import { Label, Value, Wrapper } from './DetailItem-styled-components';

interface DetailItemProps {
  label: string;
  children?: React.ReactNode;
  details?: DetailItemType[];
  gap?: number;
}

export const Details = ({ details }: { details: DetailItemType[]; }) => {
  return (
    <>
      {details.map((detail) => (
        <DetailText
          key={detail.value}
          className={!detail.isSensitive ? '' : 'sensitive-data'}
        >
          {detail.value}
        </DetailText>
      ))}
    </>
  );
};

interface DetailItemType {
  value?: string;
  isSensitive?: boolean;
}

export const DetailItem = ({ label, children, details = [], gap }: DetailItemProps) => {
  const nonEmptyDetails = details.filter(Boolean);

  if (!nonEmptyDetails?.length && !children) {
    return null;
  }

  return (
    <Wrapper>
      <Label>{label}</Label>
      <Value $gap={gap}>
        <Details details={nonEmptyDetails} />
        {children}
      </Value>
    </Wrapper>
  );
};
